import React from "react";
import { Box, Skeleton } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";

import CustomCircleButton from "../../CustomCircleButton";

const PlayListLoading = () => {
  return (
    <Box
      sx={{
        border: "2px solid",
        borderColor: "black.main",
        borderRadius: "16px",
        minHeight: "80px",
        display: "flex",
        alignItems: "center",
        padding: "16px",
        justifyContent: "space-between",
        marginBottom: "16px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Skeleton
          sx={{ mr: "8px", borderRadius: "8px" }}
          variant='rounded'
          width={48}
          height={48}
        />

        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: "3px",
            }}
          >
            <Skeleton width={115} />
          </Box>

          <Skeleton width={70} height={15} />
        </Box>
      </Box>
      <Box>
        <CustomCircleButton
          width='40px'
          height='40px'
          bgColor='white.main'
          color='black.main'
          bShadow='none'
          border='2px solid'
          hoverBgColor='white.main'
          hoverColor='black.main'
          hoverBorder={`2px solid`}
          activeBgColor='black.main'
          activeColor='white.main'
        >
          <PlayArrowRoundedIcon sx={{ fontSize: "26px" }} />
        </CustomCircleButton>
      </Box>
    </Box>
  );
};

export default PlayListLoading;
